module.exports = {"app.menu.home":"Home","app.menu.statistics":"Statistics","app.menu.scan_qr":"Scan QR","app.menu.login":"Login","app.menu.contacts":"Contacts","app.menu.diagrams":"Diagrams","app.menu.profile":"Profile","app.menu.logout":"Logout","app.menu.manage":"Manage","app.menu.companies":"Companies","app.menu.users":"Users","home.machine_list":"Machine List"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = 1048
// module chunks = 0